import { render } from "./ProfileEdit.vue?vue&type=template&id=07a38509&scoped=true&ts=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=ts"
export * from "./ProfileEdit.vue?vue&type=script&lang=ts"

import "./ProfileEdit.vue?vue&type=style&index=0&id=07a38509&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a38509"]])

export default __exports__